import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import BaseComponent from '../../../base.component';
import { FilterResponse } from 'src/app/shared/models/filter-response';

@Component({
    selector: 'cdp-single-select',
    templateUrl: './single-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SingleSelectComponent<TItemType, TBindValueType> extends BaseComponent implements OnInit {
    @Input() clearable = true;
    @Input() loading: boolean;
    @Input() placeholder: string;
    @Input() tooltip?: string;
    @Input() controlName: string;
    @Input() bindLabel: string;

    private _selection: ReadonlyArray<TBindValueType> = [];
    get selection(): ReadonlyArray<TBindValueType> {
        return this._selection;
    }
    @Input()
    set selection(value: ReadonlyArray<TBindValueType>) {
        if (value !== this._selection) {
            if (!value?.length) {
                this._selection = [];
                this.selectedItemsControl.setValue(undefined);
            } else {
                this._selection = value;
                this.selectedItemsControl.setValue(value[0]);
            }
        }
    }

    mutableItems: TItemType[];

    get items(): ReadonlyArray<TItemType> {
        return this.mutableItems;
    }
    @Input()
    set items(value: ReadonlyArray<TItemType>) {
        this.mutableItems = [...value];
    }

    @Output() selectionChange: EventEmitter<FilterResponse<TBindValueType>> = new EventEmitter<
        FilterResponse<TBindValueType>
    >();

    readonly selectedItemsControl: FormControl = new FormControl([]);
    readonly singleSelectGroup = new FormGroup({
        selectedItemsControl: this.selectedItemsControl
    });

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.selectedItemsControl.valueChanges
            .pipe(this.unsubscribeOnDestroy())
            .subscribe((selection: TBindValueType) => {
                if (this.selection[0] !== selection) {
                    this.selection = [selection];
                    const response: FilterResponse<TBindValueType> = {
                        name: this.controlName,
                        selection: selection ? [selection] : []
                    };
                    this.selectionChange.emit(response);
                }
            });
    }
}
